export type SnackBarState = {
    openSnackBar: boolean ,
    isSuccess:boolean,
    message:string 

}
  
    export const initSnackBardState: SnackBarState = {
      openSnackBar:false,
      isSuccess:false,
      message: ""
    };
    